import { memo } from 'react';
import { RadioGroup as RACRadioGroup, RadioGroupProps as RACRadioGroupProps } from 'react-aria-components';

import { merge } from '@/components';

export type RadioGroupProps = RACRadioGroupProps & {};

const IRadioGroup = ({ className, children, ...rest }: RadioGroupProps) => {
  const styles = 'flex flex-col gap-sm';
  return (
    <RACRadioGroup aria-label="radiogroup" className={merge(styles, className)} {...rest}>
      {children}
    </RACRadioGroup>
  );
};

export const RadioGroup = memo(IRadioGroup) as typeof IRadioGroup;
